<template>
    <v-layout v-if="table.content.pagination.pages >= 1" mt-5 align-center
              wrap
    >
        <v-flex xs12>
            <v-layout :class="{
                          'row': $vuetify.breakpoint.mdAndUp,
                          'column': $vuetify.breakpoint.mdAndDown,
                          'justify-center': $vuetify.breakpoint.mdAndDown
                      }" wrap justify-space-between
                      align-center
            >
                <v-flex xs12 sm8 md7
                        lg6
                >
                    <v-pagination
                        v-model="pagination"
                        v-if="table.content.pagination.pages > 1"
                        :length="pages"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </v-flex>
                <v-flex :class="{'mt-4': $vuetify.breakpoint.mdAndDown}" xs8 sm8
                        md7 lg6
                >
                    <v-select
                        :items="$vuetify.breakpoint.mdAndUp ?
                            [
                                {
                                    text: $t('Показывать по 10'),
                                    value: 'Показывать по 10',
                                },
                                {
                                    text: $t('Показывать по 25'),
                                    value: 'Показывать по 25',
                                },
                                {
                                    text: $t('Показывать по 50'),
                                    value: 'Показывать по 50',
                                },
                                {
                                    text: $t('Показывать по 100'),
                                    value: 'Показывать по 100',
                                },
                            ]
                            :
                            [
                                {
                                    text: $t('Показывать по 10'),
                                    value: 'Показывать по 10',
                                },
                                {
                                    text: $t('Показывать по 25'),
                                    value: 'Показывать по 25',
                                },
                                {
                                    text: $t('Показывать по 50'),
                                    value: 'Показывать по 50',
                                },
                        ]"
                        solo
                        append-icon=""
                        :label="$t('Показывать по 10')"
                        class="input"
                        @change="show_number($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapMutations, mapActions} from 'vuex';

export default {
  props: {
    table: {
      type: Object,
    },
    request: {
      type: Object,
    },
    tab: {
      type: String,
    },
  },
  computed: {
    pages() {
      if (this.table.content.pagination.pages) {
        return this.table.content.pagination.pages;
      } else if (this.table.content.pagination.rowsPerPage == null || this.table.content.body.length == null) {
        return 0;
      }


      return Math.ceil(this.table.content.body.length / this.table.content.pagination.rowsPerPage);
    },
    pagination: {
      get() {
        return this.table.content.pagination.page;
      },
      set($event) {
        if (this.tab === 'organizations') {
          this.SET_COMPANY_PAGE($event);
          this.get_org_rating({
            page    : this.table.content.pagination.page,
            pageSize: this.table.content.pagination.rowsPerPage,
          });
        } else if (this.tab === 'org_employee') {
          this.SET_ORG_EMPLOYEES_PAGE($event);
          this.get_employees_rating({
            page    : this.table.content.pagination.page,
            pageSize: this.table.content.pagination.rowsPerPage,
          });
        } else if (this.tab === 'all') {
          this.SET_COMMON_EMPLOYEES_PAGE($event);
          this.get_common_rating({
            page    : this.table.content.pagination.page,
            pageSize: this.table.content.pagination.rowsPerPage,
          });
        } else if (this.tab === 'tests_result') {
          this.SET_COURSES_VERIFICATION_PAGE($event);
          return this.get_courses_verification({
            filter: {
              ...this.request, sort_name     : this.table.content.pagination.sortBy || null,
              sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
            },
            page   : this.table.content.pagination.page,
            perPage: this.table.content.pagination.rowsPerPage,
          });
        }
      },
    },
  },
  methods: {
    ...mapActions('rating/companies', [
      'change_organization_per_page',
    ]),
    ...mapActions('rating/org_employees', [
      'change_org_employees_per_page',
    ]),
    ...mapActions('rating/common_employees', [
      'change_common_employees_per_page',
    ]),
    ...mapActions('employee_study', [
      'get_courses_verification',
    ]),
    ...mapMutations('employee_study/coursesVerification', [
      'SET_COURSES_VERIFICATION_PAGE',
    ]),
    ...mapActions('employee_study/coursesVerification', [
      'change_courses_verification_per_page',
    ]),
    ...mapMutations('rating/companies', [
      'SET_COMPANY_PAGE',
    ]),
    ...mapMutations('rating/org_employees', [
      'SET_ORG_EMPLOYEES_PAGE',
    ]),
    ...mapMutations('rating/common_employees', [
      'SET_COMMON_EMPLOYEES_PAGE',
    ]),
    ...mapMutations('rating/common_employees', [
      'SET_COMMON_EMPLOYEES_PAGE',
    ]),
    ...mapActions('rating', [
      'get_org_rating',
      'get_common_rating',
      'get_employees_rating',
    ]),
    async show_number(event) {
      if (this.tab === 'organizations') {
        await this.change_organization_per_page(event);
        return this.get_org_rating({
          page    : this.table.content.pagination.page,
          pageSize: this.table.content.pagination.rowsPerPage,
        });
      } else if (this.tab === 'org_employee') {
        await this.change_org_employees_per_page(event);
        return this.get_employees_rating({
          page    : this.table.content.pagination.page,
          pageSize: this.table.content.pagination.rowsPerPage,
        });
      } else if (this.tab === 'all') {
        await this.change_common_employees_per_page(event);
        return this.get_common_rating({
          page    : this.table.content.pagination.page,
          pageSize: this.table.content.pagination.rowsPerPage,
        });
      } else if (this.tab === 'tests_result') {
        let perPage = this.table.content.pagination.rowsPerPage;
        if (event === 'Показывать по 10') {
          perPage = 10;
        } else if (event === 'Показывать по 25') {
          perPage = 25;
        } else if (event === 'Показывать по 50') {
          perPage = 50;
        } else if (event === 'Показывать по 100') {
          perPage = 100;
        }
        await this.change_courses_verification_per_page(perPage);
        return this.get_courses_verification({
          filter: {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy || null,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
          page   : this.table.content.pagination.page,
          perPage: this.table.content.pagination.rowsPerPage,
        });
      }
    },
  },
};
</script>

